
    // const getStatusLogin = (state) => state.is_logging 
export default {
    // getStatusLogin,
};
